// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rating-short-dialog {
  width: 100%;
  max-width: 800px;
  min-width: 500px;
  padding: 0;
}
.rating-short-dialog .dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
}
.rating-short-dialog .dialog-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  color: #333;
}
.rating-short-dialog .dialog-header .close-button {
  color: #666;
}
.rating-short-dialog .dialog-content {
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
}
.rating-short-dialog .dialog-content .flow-info {
  margin-bottom: 24px;
  text-align: center;
}
.rating-short-dialog .dialog-content .flow-info h3 {
  margin: 0 0 8px 0;
  font-size: 20px;
  color: #333;
}
.rating-short-dialog .dialog-content .flow-info p {
  margin: 0;
  color: #666;
  font-size: 14px;
}
.rating-short-dialog .dialog-content .rating-section {
  margin-bottom: 24px;
}
.rating-short-dialog .dialog-content .rating-section label {
  display: block;
  margin-bottom: 12px;
  font-weight: 500;
  color: #333;
}
.rating-short-dialog .dialog-content .rating-section .star-rating {
  display: flex;
  gap: 8px;
  justify-content: center;
}
.rating-short-dialog .dialog-content .rating-section .star-rating .star-button {
  color: #ffc107;
}
.rating-short-dialog .dialog-content .rating-section .star-rating .star-button.active {
  color: #ffc107;
}
.rating-short-dialog .dialog-content .rating-section .star-rating .star-button mat-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
}
.rating-short-dialog .dialog-content .review-section {
  margin-bottom: 24px;
}
.rating-short-dialog .dialog-content .review-section label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}
.rating-short-dialog .dialog-content .review-section .review-textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;
}
.rating-short-dialog .dialog-content .review-section .review-textarea:focus {
  outline: none;
  border-color: #5ea1d8;
}
.rating-short-dialog .dialog-content .media-section {
  margin-bottom: 24px;
}
.rating-short-dialog .dialog-content .media-section label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}
.rating-short-dialog .dialog-content .media-section .help-text {
  margin: 0 0 12px 0;
  color: #666;
  font-size: 12px;
}
.rating-short-dialog .dialog-content .media-section .upload-area {
  text-align: center;
  padding: 20px;
  border: 2px dashed #ddd;
  border-radius: 6px;
  background-color: #f9f9f9;
}
.rating-short-dialog .dialog-content .media-section .upload-area button.mat-raised-button {
  font-family: "Raleway" !important;
  min-width: 120px !important;
  height: auto !important;
  min-height: auto !important;
  font-weight: normal !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  border-radius: 10px !important;
  transition: all 0.3s ease !important;
  padding: 10px 16px !important;
  border: none !important;
  cursor: pointer !important;
  line-height: 1.5 !important;
  margin-bottom: 12px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  box-sizing: border-box !important;
  color: white !important;
  background-color: #5ea1d8 !important;
  box-shadow: none !important;
  white-space: nowrap !important;
  overflow: visible !important;
  text-overflow: clip !important;
  text-align: center !important;
  font-size: 16px !important;
}
.rating-short-dialog .dialog-content .media-section .upload-area button.mat-raised-button ::ng-deep .mat-button-wrapper,
.rating-short-dialog .dialog-content .media-section .upload-area button.mat-raised-button ::ng-deep .mdc-button__label {
  white-space: nowrap !important;
  overflow: visible !important;
  text-overflow: clip !important;
  text-align: center !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  line-height: 1.5 !important;
  font-size: 16px !important;
}
.rating-short-dialog .dialog-content .media-section .upload-area button.mat-raised-button:hover:not(:disabled) {
  background-color: #4a90c6 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;
}
.rating-short-dialog .dialog-content .media-section .upload-area button.mat-raised-button:active:not(:disabled) {
  transform: translateY(0) !important;
}
.rating-short-dialog .dialog-content .media-section .upload-area button.mat-raised-button:disabled {
  background-color: #ccc !important;
  color: #999 !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}
.rating-short-dialog .dialog-content .media-section .upload-area button.mat-raised-button mat-icon {
  font-size: 20px !important;
  width: 20px !important;
  height: 20px !important;
  flex-shrink: 0 !important;
  overflow: visible !important;
}
.rating-short-dialog .dialog-content .media-section .upload-area .progress-bar {
  margin-top: 12px;
}
.rating-short-dialog .dialog-content .media-section .upload-area .progress-bar mat-progress-bar {
  margin-bottom: 8px;
}
.rating-short-dialog .dialog-content .media-section .upload-area .progress-bar span {
  display: block;
  font-size: 12px;
  color: #666;
}
.rating-short-dialog .dialog-content .media-section .media-preview {
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  background-color: #000;
}
.rating-short-dialog .dialog-content .media-section .media-preview .video-preview,
.rating-short-dialog .dialog-content .media-section .media-preview .image-preview {
  width: 100%;
  max-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rating-short-dialog .dialog-content .media-section .media-preview .video-preview video,
.rating-short-dialog .dialog-content .media-section .media-preview .video-preview img,
.rating-short-dialog .dialog-content .media-section .media-preview .image-preview video,
.rating-short-dialog .dialog-content .media-section .media-preview .image-preview img {
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
}
.rating-short-dialog .dialog-content .media-section .media-preview .remove-button {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
}
.rating-short-dialog .dialog-content .media-section .media-preview .remove-button:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.rating-short-dialog .dialog-actions {
  padding: 25px !important;
  margin: 0 !important;
  border-top: 1px solid #e0e0e0 !important;
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 12px !important;
  background-color: #fff !important;
  flex-shrink: 0;
}
.rating-short-dialog .dialog-actions button.mat-button,
.rating-short-dialog .dialog-actions button.mat-raised-button {
  font-family: "Raleway" !important;
  min-width: 100px !important;
  height: auto !important;
  min-height: auto !important;
  font-weight: normal !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  border-radius: 10px !important;
  transition: all 0.3s ease !important;
  padding: 10px !important;
  border: none !important;
  cursor: pointer !important;
  line-height: 1.5 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  text-align: center !important;
  font-size: 16px !important;
}
.rating-short-dialog .dialog-actions button.mat-button ::ng-deep .mat-button-wrapper,
.rating-short-dialog .dialog-actions button.mat-button ::ng-deep .mdc-button__label,
.rating-short-dialog .dialog-actions button.mat-raised-button ::ng-deep .mat-button-wrapper,
.rating-short-dialog .dialog-actions button.mat-raised-button ::ng-deep .mdc-button__label {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  text-align: center !important;
  display: inline-block !important;
  line-height: 1.5 !important;
  font-size: 16px !important;
}
.rating-short-dialog .dialog-actions button.mat-button.mat-button,
.rating-short-dialog .dialog-actions button.mat-raised-button.mat-button {
  color: #666 !important;
  border: 1px solid #ddd !important;
  background-color: #f8f9fa !important;
}
.rating-short-dialog .dialog-actions button.mat-button.mat-button:hover,
.rating-short-dialog .dialog-actions button.mat-raised-button.mat-button:hover {
  background-color: #e9ecef !important;
  border-color: #adb5bd !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}
.rating-short-dialog .dialog-actions button.mat-button.mat-button:active,
.rating-short-dialog .dialog-actions button.mat-raised-button.mat-button:active {
  transform: translateY(0) !important;
}
.rating-short-dialog .dialog-actions button.mat-button.mat-raised-button,
.rating-short-dialog .dialog-actions button.mat-raised-button.mat-raised-button {
  color: white !important;
  background-color: #5ea1d8 !important;
  border: none !important;
  box-shadow: 0 2px 4px rgba(94, 161, 216, 0.25) !important;
}
.rating-short-dialog .dialog-actions button.mat-button.mat-raised-button:hover:not(:disabled),
.rating-short-dialog .dialog-actions button.mat-raised-button.mat-raised-button:hover:not(:disabled) {
  background-color: #4a90c6 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;
}
.rating-short-dialog .dialog-actions button.mat-button.mat-raised-button:active:not(:disabled),
.rating-short-dialog .dialog-actions button.mat-raised-button.mat-raised-button:active:not(:disabled) {
  transform: translateY(0) !important;
}
.rating-short-dialog .dialog-actions button.mat-button.mat-raised-button:disabled,
.rating-short-dialog .dialog-actions button.mat-raised-button.mat-raised-button:disabled {
  background-color: #ccc !important;
  color: #999 !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}

:host-context(body.theme-dark) {
  /* Keep golden star color in dark mode */
}
:host-context(body.theme-dark) .rating-short-dialog .star-rating .star-button mat-icon,
:host-context(body.theme-dark) .rating-short-dialog .star-rating .star-button.active mat-icon {
  color: #ffc107 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/flow-rating-short/flow-rating-short.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AACJ;AACI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AACN;AAEI;EACE,WAAA;AAAN;AAIE;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;AAII;EACE,mBAAA;EACA,kBAAA;AAFN;AAIM;EACE,iBAAA;EACA,eAAA;EACA,WAAA;AAFR;AAKM;EACE,SAAA;EACA,WAAA;EACA,eAAA;AAHR;AAOI;EACE,mBAAA;AALN;AAOM;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AALR;AAQM;EACE,aAAA;EACA,QAAA;EACA,uBAAA;AANR;AAQQ;EACE,cAAA;AANV;AAQU;EACE,cAAA;AANZ;AASU;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAPZ;AAaI;EACE,mBAAA;AAXN;AAaM;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAXR;AAcM;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAZR;AAcQ;EACE,aAAA;EACA,qBAAA;AAZV;AAiBI;EACE,mBAAA;AAfN;AAiBM;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAfR;AAkBM;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AAhBR;AAmBM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AAjBR;AAmBQ;EACE,iCAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oCAAA;EACA,6BAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iCAAA;EACA,uBAAA;EACA,oCAAA;EACA,2BAAA;EACA,8BAAA;EACA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;AAjBV;AAmBU;;EAEE,8BAAA;EACA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,mBAAA;EACA,2BAAA;EACA,0BAAA;AAjBZ;AAoBU;EACE,oCAAA;EACA,sCAAA;EACA,wDAAA;AAlBZ;AAqBU;EACE,mCAAA;AAnBZ;AAsBU;EACE,iCAAA;EACA,sBAAA;EACA,8BAAA;EACA,2BAAA;AApBZ;AAuBU;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,4BAAA;AArBZ;AAyBQ;EACE,gBAAA;AAvBV;AAyBU;EACE,kBAAA;AAvBZ;AA0BU;EACE,cAAA;EACA,eAAA;EACA,WAAA;AAxBZ;AA6BM;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AA3BR;AA6BQ;;EAEE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA3BV;AA6BU;;;;EAEE,eAAA;EACA,iBAAA;EACA,mBAAA;AAzBZ;AA6BQ;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oCAAA;EACA,YAAA;AA3BV;AA6BU;EACE,oCAAA;AA3BZ;AAkCE;EACE,wBAAA;EACA,oBAAA;EACA,wCAAA;EACA,wBAAA;EACA,oCAAA;EACA,8BAAA;EACA,oBAAA;EACA,iCAAA;EACA,cAAA;AAhCJ;AAkCI;;EAEE,iCAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oCAAA;EACA,wBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,oBAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCAAA;EACA,6BAAA;EACA,0BAAA;AAhCN;AAkCM;;;;EAEE,8BAAA;EACA,2BAAA;EACA,kCAAA;EACA,6BAAA;EACA,gCAAA;EACA,2BAAA;EACA,0BAAA;AA9BR;AAiCM;;EACE,sBAAA;EACA,iCAAA;EACA,oCAAA;AA9BR;AAgCQ;;EACE,oCAAA;EACA,gCAAA;EACA,sCAAA;EACA,mDAAA;AA7BV;AAgCQ;;EACE,mCAAA;AA7BV;AAiCM;;EACE,uBAAA;EACA,oCAAA;EACA,uBAAA;EACA,yDAAA;AA9BR;AAgCQ;;EACE,oCAAA;EACA,sCAAA;EACA,wDAAA;AA7BV;AAgCQ;;EACE,mCAAA;AA7BV;AAgCQ;;EACE,iCAAA;EACA,sBAAA;EACA,8BAAA;EACA,2BAAA;AA7BV;;AAoCA;EACE,wCAAA;AAjCF;AAkCE;;EAEE,yBAAA;AAhCJ","sourcesContent":[".rating-short-dialog {\n  width: 100%;\n  max-width: 800px;\n  min-width: 500px;\n  padding: 0;\n\n  .dialog-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px;\n    border-bottom: 1px solid #e0e0e0;\n\n    h2 {\n      margin: 0;\n      font-size: 24px;\n      font-weight: 500;\n      color: #333;\n    }\n\n    .close-button {\n      color: #666;\n    }\n  }\n\n  .dialog-content {\n    padding: 24px;\n    max-height: 70vh;\n    overflow-y: auto;\n\n    .flow-info {\n      margin-bottom: 24px;\n      text-align: center;\n\n      h3 {\n        margin: 0 0 8px 0;\n        font-size: 20px;\n        color: #333;\n      }\n\n      p {\n        margin: 0;\n        color: #666;\n        font-size: 14px;\n      }\n    }\n\n    .rating-section {\n      margin-bottom: 24px;\n\n      label {\n        display: block;\n        margin-bottom: 12px;\n        font-weight: 500;\n        color: #333;\n      }\n\n      .star-rating {\n        display: flex;\n        gap: 8px;\n        justify-content: center;\n\n        .star-button {\n          color: #ffc107;\n\n          &.active {\n            color: #ffc107;\n          }\n\n          mat-icon {\n            font-size: 40px;\n            width: 40px;\n            height: 40px;\n          }\n        }\n      }\n    }\n\n    .review-section {\n      margin-bottom: 24px;\n\n      label {\n        display: block;\n        margin-bottom: 8px;\n        font-weight: 500;\n        color: #333;\n      }\n\n      .review-textarea {\n        width: 100%;\n        padding: 12px;\n        border: 1px solid #ddd;\n        border-radius: 6px;\n        font-family: inherit;\n        font-size: 14px;\n        resize: vertical;\n        box-sizing: border-box;\n\n        &:focus {\n          outline: none;\n          border-color: #5ea1d8;\n        }\n      }\n    }\n\n    .media-section {\n      margin-bottom: 24px;\n\n      label {\n        display: block;\n        margin-bottom: 8px;\n        font-weight: 500;\n        color: #333;\n      }\n\n      .help-text {\n        margin: 0 0 12px 0;\n        color: #666;\n        font-size: 12px;\n      }\n\n      .upload-area {\n        text-align: center;\n        padding: 20px;\n        border: 2px dashed #ddd;\n        border-radius: 6px;\n        background-color: #f9f9f9;\n\n        button.mat-raised-button {\n          font-family: \"Raleway\" !important;\n          min-width: 120px !important;\n          height: auto !important;\n          min-height: auto !important;\n          font-weight: normal !important;\n          text-transform: none !important;\n          letter-spacing: normal !important;\n          border-radius: 10px !important;\n          transition: all 0.3s ease !important;\n          padding: 10px 16px !important;\n          border: none !important;\n          cursor: pointer !important;\n          line-height: 1.5 !important;\n          margin-bottom: 12px !important;\n          display: inline-flex !important;\n          align-items: center !important;\n          justify-content: center !important;\n          gap: 8px !important;\n          box-sizing: border-box !important;\n          color: white !important;\n          background-color: #5ea1d8 !important;\n          box-shadow: none !important;\n          white-space: nowrap !important;\n          overflow: visible !important;\n          text-overflow: clip !important;\n          text-align: center !important;\n          font-size: 16px !important;\n          \n          ::ng-deep .mat-button-wrapper,\n          ::ng-deep .mdc-button__label {\n            white-space: nowrap !important;\n            overflow: visible !important;\n            text-overflow: clip !important;\n            text-align: center !important;\n            display: inline-flex !important;\n            align-items: center !important;\n            justify-content: center !important;\n            gap: 8px !important;\n            line-height: 1.5 !important;\n            font-size: 16px !important;\n          }\n          \n          &:hover:not(:disabled) {\n            background-color: #4a90c6 !important;\n            transform: translateY(-1px) !important;\n            box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;\n          }\n\n          &:active:not(:disabled) {\n            transform: translateY(0) !important;\n          }\n\n          &:disabled {\n            background-color: #ccc !important;\n            color: #999 !important;\n            cursor: not-allowed !important;\n            box-shadow: none !important;\n          }\n\n          mat-icon {\n            font-size: 20px !important;\n            width: 20px !important;\n            height: 20px !important;\n            flex-shrink: 0 !important;\n            overflow: visible !important;\n          }\n        }\n\n        .progress-bar {\n          margin-top: 12px;\n\n          mat-progress-bar {\n            margin-bottom: 8px;\n          }\n\n          span {\n            display: block;\n            font-size: 12px;\n            color: #666;\n          }\n        }\n      }\n\n      .media-preview {\n        position: relative;\n        border-radius: 6px;\n        overflow: hidden;\n        background-color: #000;\n\n        .video-preview,\n        .image-preview {\n          width: 100%;\n          max-height: 300px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n\n          video,\n          img {\n            max-width: 100%;\n            max-height: 300px;\n            object-fit: contain;\n          }\n        }\n\n        .remove-button {\n          position: absolute;\n          top: 8px;\n          right: 8px;\n          background-color: rgba(0, 0, 0, 0.6);\n          color: white;\n\n          &:hover {\n            background-color: rgba(0, 0, 0, 0.8);\n          }\n        }\n      }\n    }\n  }\n\n  .dialog-actions {\n    padding: 25px !important;\n    margin: 0 !important;\n    border-top: 1px solid #e0e0e0 !important;\n    display: flex !important;\n    justify-content: flex-end !important;\n    align-items: center !important;\n    gap: 12px !important;\n    background-color: #fff !important;\n    flex-shrink: 0;\n\n    button.mat-button,\n    button.mat-raised-button {\n      font-family: \"Raleway\" !important;\n      min-width: 100px !important;\n      height: auto !important;\n      min-height: auto !important;\n      font-weight: normal !important;\n      text-transform: none !important;\n      letter-spacing: normal !important;\n      border-radius: 10px !important;\n      transition: all 0.3s ease !important;\n      padding: 10px !important;\n      border: none !important;\n      cursor: pointer !important;\n      line-height: 1.5 !important;\n      margin: 0 !important;\n      display: inline-flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n      box-sizing: border-box !important;\n      white-space: nowrap !important;\n      overflow: hidden !important;\n      text-overflow: ellipsis !important;\n      text-align: center !important;\n      font-size: 16px !important;\n      \n      ::ng-deep .mat-button-wrapper,\n      ::ng-deep .mdc-button__label {\n        white-space: nowrap !important;\n        overflow: hidden !important;\n        text-overflow: ellipsis !important;\n        text-align: center !important;\n        display: inline-block !important;\n        line-height: 1.5 !important;\n        font-size: 16px !important;\n      }\n\n      &.mat-button {\n        color: #666 !important;\n        border: 1px solid #ddd !important;\n        background-color: #f8f9fa !important;\n\n        &:hover {\n          background-color: #e9ecef !important;\n          border-color: #adb5bd !important;\n          transform: translateY(-1px) !important;\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n        }\n\n        &:active {\n          transform: translateY(0) !important;\n        }\n      }\n\n      &.mat-raised-button {\n        color: white !important;\n        background-color: #5ea1d8 !important;\n        border: none !important;\n        box-shadow: 0 2px 4px rgba(94, 161, 216, 0.25) !important;\n\n        &:hover:not(:disabled) {\n          background-color: #4a90c6 !important;\n          transform: translateY(-1px) !important;\n          box-shadow: 0 4px 8px rgba(94, 161, 216, 0.3) !important;\n        }\n\n        &:active:not(:disabled) {\n          transform: translateY(0) !important;\n        }\n\n        &:disabled {\n          background-color: #ccc !important;\n          color: #999 !important;\n          cursor: not-allowed !important;\n          box-shadow: none !important;\n        }\n      }\n    }\n  }\n}\n\n:host-context(body.theme-dark) {\n  /* Keep golden star color in dark mode */\n  .rating-short-dialog .star-rating .star-button mat-icon,\n  .rating-short-dialog .star-rating .star-button.active mat-icon {\n    color: #ffc107 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
